const TransitionExpand = {
  name: 'TransitionExpand',
  functional: true,
  render(createElement, context) {
    const data = {
      props: {
        name: 'expand',
      },
      on: {
        afterEnter(element) {
          element.style.height = 'auto';
        },
        enter(element) {
          const { width } = getComputedStyle(element);

          element.style.width = width;
          element.style.position = 'absolute';
          element.style.visibility = 'hidden';
          element.style.height = 'auto';

          const { height } = getComputedStyle(element);

          element.style.width = '';
          element.style.position = '';
          element.style.visibility = '';
          element.style.height = 0;

          setTimeout(function() {
            element.style.height = height;
          }, 100);
        },
        leave(element) {
          const { height } = getComputedStyle(element);

          element.style.height = height;

          setTimeout(function() {
            element.style.height = 0;
          }, 100);
        },
      },
    };
    return createElement('transition', data, context.children);
  },
};

export default TransitionExpand;



// WEBPACK FOOTER //
// ../shared/animations/transition-expand.js